import { render } from "./layout.html?vue&type=template&id=2ce18123&scoped=true"
import script from "./IziLayout.vue?vue&type=script&lang=ts"
export * from "./IziLayout.vue?vue&type=script&lang=ts"

import "./layout.scss?vue&type=style&index=0&id=2ce18123&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ce18123"

export default script